const routes = [
    {
        path: "/",
        component: () => import("../views/Home/index.vue")
    },

    {
        path: "/social-media",
        component: () => import("../views/SocialMedia/index.vue")
    },

    {
        path: "/tabs",
        component: () => import("../views/Tabs/index.vue")
    },

    {
        path: "/standard-picture",
        component: () => import("../views/StandardPicture/index.vue")
    },

    {
        path: "/awesome",
        component: () => import("../views/Awesome/index.vue")
    },

    {
        path: "/pricing-options",
        component: () => import("../views/PricingOptions/index.vue")
    },

    {
        path: "/testimonials",
        component: () => import("../views/Testimonials/index.vue")
    },

    {
        path: "/stylish",
        component: () => import("../views/Stylish/index.vue")
    },

    {
        path: "/contact-us",
        component: () => import("../views/ContactUs/index.vue")
    },

    {
        path: "*",
        component: () => import("../views/PageNotFound/index.vue")
    }

]

export default routes